import styled, { keyframes } from '@nfinite/react-hubstairs/styled'

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const ItemContainer = styled('div')`
  & > * {
    animation-name: ${fadeIn};
    animation-duration: 80ms;
    animation-delay: 0ms;
    animation-fill-mode: both;
    animation-direction: normal;
  }
`
